import { render, staticRenderFns } from "./DwOverallTotalMembers.vue?vue&type=template&id=e80c1786&"
import script from "./DwOverallTotalMembers.vue?vue&type=script&lang=js&"
export * from "./DwOverallTotalMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports